/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as segmentio from 'rp-analytics';

/**
 * Component that is used for rendering race
 * @param race
 * @param isAnchorSet
 * @param colour
 */
const Race = ({ race, isAnchorSet, racecourse, prefTab }) => {
    const {
        result,
        started,
        isNextRace,
        hasRaceOffers,
        link,
        runners,
        id,
        date,
        time,
        abandoned,
        isThirthyMinToNextRace,
        title,
    } = race;
    const isFutureRace = !result && !started && !(isThirthyMinToNextRace && isNextRace);
    const offersAvailable = hasRaceOffers && !result;
    const getRaceClass = () => classNames(
        'ui-link',
        'rh-cardsMatrix__race',
        {
            'rh-cardsMatrix__race--result': (result || started) && !isNextRace,
            'js-popupLink': result,
            'rh-cardsMatrix__race--card': isFutureRace,
            'js-navigate-url': !result && isAnchorSet,
            'rh-cardsMatrix__race--next': isNextRace && isThirthyMinToNextRace,
        }
    );
    const prefLink = (!result && isAnchorSet && prefTab !== 'free')
        ? `${link}/${prefTab}` : link;
    const getLabel = () => {
        if (result) return 'Result';
        if (started && !isNextRace) return 'Race off';
        return `${runners} ${runners > 1 ? 'runners' : 'runner'}`;
    };
    const trackClick = (e) => {
        e.preventDefault();
        segmentio.trackRaceMatrixClick({
            [segmentio.TRAIT_RACE_ID]: id,
            [segmentio.TRAIT_RACE_DATE]: date,
            [segmentio.TRAIT_RACE_TIME]: time,
            [segmentio.TRAIT_RACECOURSE]: racecourse,
            [segmentio.TRAIT_RACE_OFFERS_AVAILABLE]: offersAvailable ? 'Yes' : 'No',
        }).then(() => {
            if (!result) {
                location.href = prefLink;
            }
        });
    };

    return (
        abandoned ?
            <span
                className="rh-cardsMatrix__race rh-cardsMatrix__race--abandoned"
            >
                <span className="rh-cardsMatrix__raceTime">{time}</span>
                <span className="rh-cardsMatrix__raceLabel">Abandoned</span>
            </span> :
            <a
                href={link}
                className={getRaceClass()}
                title={title}
                onClick={trackClick}
            >
                <div className="rh-cardsMatrix__raceTimeContainer">
                    <span className="rh-cardsMatrix__raceTime">
                        {time}
                    </span>
                    {offersAvailable &&
                        <span className="rh-cardsMatrix__raceOfferLabel">
                            Offer
                        </span>
                    }
                </div>
                <span className="rh-cardsMatrix__raceLabel">{getLabel()}</span>
            </a>
    );
};

Race.propTypes = {
    race: PropTypes.shape({
        /**
         * Is race abandoned
         */
        abandoned: PropTypes.bool.isRequired,
        /**
         * Race result
         */
        result: PropTypes.bool.isRequired,
        /**
         * Race time
         */
        link: PropTypes.string.isRequired,
        /**
         * Race title
         */
        title: PropTypes.string.isRequired,
        /**
         * Race time
         */
        time: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        /**
         * Race number of runners
         */
        runners: PropTypes.number.isRequired,
        /**
         * Has race offers
         */
        hasRaceOffers: PropTypes.bool.isRequired,
        /**
         * Is next race
         */
        isNextRace: PropTypes.bool.isRequired,
        /**
         * Is Race started
         */
        /**
         * Is next race less than 30 min away
         */
        isThirthyMinToNextRace: PropTypes.bool.isRequired,
        started: PropTypes.bool.isRequired,
    }).isRequired,
    /**
     * Is anchor set
     */
    isAnchorSet: PropTypes.bool.isRequired,
    /**
     * Pref tab fro cards links
     */
    prefTab: PropTypes.string.isRequired,
    /**
     * Racecourse name
     */
    racecourse: PropTypes.string.isRequired,
};

export { Race as default };



// WEBPACK FOOTER //
// ./src/js/Cards/components/Race/Race.js